import React from 'react'
import './WhyHireUs.css'
import WhuImg from '../../../../assets/img/whu.webp'
import pd from '../../../../assets/img/project_delivered.svg'
import hc from '../../../../assets/img/happy_clients.svg'
import tc from '../../../../assets/img/coffee.svg'
import CountUpOnScroll from '../../Home/About/ScrollCounter'

function WhyHIreUs() {
  return (
    <section className='whu-sec'>
        <div className='container'>
            <div className='whu-sec1'>
                <div className='whulft'></div>
                <div className='whurgt'>
                    <h3>What We Build</h3>
                    <ul>
                        <li>Enterprise resource planning solutions tailored to your workflows</li>
                        <li>Custom CRM and customer engagement platforms</li>
                        <li>Specialized industry systems for retail, logistics, healthcare, finance, and more</li>
                        <li>Automation tools and workflow orchestration engines</li>
                        <li>Analytics and reporting modules integrated into your applications</li>
                    </ul>
                    
                </div>
            </div>
        </div>
    </section>
  )
}

export default WhyHIreUs
